import { SearchIcon } from '@/Components/Common/Icons';
import { CloseOutlined } from '@ant-design/icons';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SearchInput } from './HSSearchInput.styles';

export const HSSearchInput = ({ value, onChange, onClear, autoFocus = false }) => {
  const trans = useSelector(translator);

  return (
    <SearchInput
      autoFocus={autoFocus}
      value={value}
      placeholder={trans('SEARCH')}
      aria-label={trans('SEARCH')}
      prefix={<SearchIcon style={{ height: '24px', width: '24px' }} />}
      onChange={(event) => onChange(event?.target?.value ?? '')}
      allowClear={{
        clearIcon: (
          <CloseOutlined
            style={{ fontSize: '16px', color: '#113e57' }}
            title={trans('CLEARSEARCH')}
          />
        ),
      }}
      onClear={onClear}
    />
  );
};

HSSearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
};
